import React from 'react';
import { Typography, Container, Menu, MenuItem, Switch } from '@mui/material';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import MenuIcon from '@mui/icons-material/Menu';
import { StyledAppBar, StyledToolbar, NavButtons, NavButton, ThemeToggle, MobileMenuButton } from '../styles/NavbarStyles';
import { useNavbar } from '../utils/NavbarUtils';

const NavbarComp = () => {
  const {
    isScrolled,
    isDarkMode,
    toggleTheme,
    anchorEl,
    isMenuOpen,
    menuItems,
    handleMenu,
    handleClose,
    scrollToSection,
  } = useNavbar();

  return (
    <StyledAppBar position="fixed" elevation={isScrolled ? 4 : 0}>
      <Container maxWidth="lg">
        <StyledToolbar>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
            Victor Neil
          </Typography>
          <NavButtons>
            {menuItems.map((item) => (
              <NavButton key={item.id} onClick={() => scrollToSection(item.id)}>
                {item.label}
              </NavButton>
            ))}
            <ThemeToggle>
              <Brightness7Icon />
              <Switch checked={isDarkMode} onChange={toggleTheme} color="default" />
              <Brightness4Icon />
            </ThemeToggle>
          </NavButtons>
          <MobileMenuButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleMenu}
          >
            <MenuIcon />
          </MobileMenuButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleClose}
          >
            {menuItems.map((item) => (
              <MenuItem key={item.id} onClick={() => scrollToSection(item.id)}>
                {item.label}
              </MenuItem>
            ))}
            <MenuItem>
              <ThemeToggle>
                <Brightness7Icon />
                <Switch checked={isDarkMode} onChange={toggleTheme} color="default" />
                <Brightness4Icon />
              </ThemeToggle>
            </MenuItem>
          </Menu>
        </StyledToolbar>
      </Container>
    </StyledAppBar>
  );
};

export default NavbarComp;
